import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';

import Header from './components/Header';
import BackToTopButton from './components/BackToTopButton';
import Footer from './components/Footer';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutUsPage = lazy(() => import('./pages/AboutUsPage'));
const CoreBusinessPage = lazy(() => import('./pages/CoreBusinessPage'));
const PropertyDevelopmentPage = lazy(() => import('./pages/PropertyDevelopmentPage'));
const ConstructionPage = lazy(() => import('./pages/ConstructionPage'));
const KeyPersonnelPage = lazy(() => import('./pages/KeyPersonnelPage'));
const HighlightsPage = lazy(() => import('./pages/HighlightsPage'));
const ContactUsPage = lazy(() => import('./pages/ContactUsPage'));
const TermsOfUsePage = lazy(() => import('./pages/TermsOfUsePage'));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage'));

import './assets/css/main.css';

function App() {
  return (
    <div>
      <div className="container">
        <Header />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/aboutus" element={<AboutUsPage />} />
            <Route path="/corebusiness" element={<CoreBusinessPage />} />
            <Route path="/propertydevelopment" element={<PropertyDevelopmentPage />} />
            <Route path="/construction" element={<ConstructionPage />} />
            <Route path="/keypersonnel" element={<KeyPersonnelPage />} />
            <Route path="/highlights" element={<HighlightsPage />} />
            <Route path="/contactus" element={<ContactUsPage />} />
            <Route path="/termsofuse" element={<TermsOfUsePage />} />
            <Route path="/thankyou" element={<ThankYouPage />} />
          </Routes>
        </Suspense>
        <BackToTopButton />
      </div>
      <Footer />
    </div>
  );
}

export default App; 